var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.303828 14.4404C-0.0926563 14.8167 -0.102422 15.4354 0.282344 15.8231L4.12805 19.6992L4.1289 19.6998C4.31066 19.8837 4.56323 20 4.84582 20C5.12841 20 5.38098 19.8837 5.56274 19.6998L5.56359 19.6992L9.41027 15.8231C9.79504 15.4354 9.78527 14.8167 9.38879 14.4404C8.9923 14.0642 8.35949 14.0737 7.97473 14.4614L5.84582 16.6068V0.977846C5.84582 0.437357 5.39855 0 4.84582 0C4.29309 0 3.84582 0.437357 3.84582 0.977846V16.6065L1.71789 14.4614C1.33312 14.0737 0.700312 14.0642 0.303828 14.4404Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8799 6.99103C24.8799 6.45054 24.4326 6.01318 23.8799 6.01318H13.0283C12.4756 6.01318 12.0283 6.45054 12.0283 6.99103C12.0283 7.53152 12.4756 7.96887 13.0283 7.96887H23.8799C24.4326 7.96887 24.8799 7.53152 24.8799 6.99103Z",
    fill: "#007AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7598 13.0051C21.7598 12.4646 21.3125 12.0273 20.7598 12.0273H13.0283C12.4756 12.0273 12.0283 12.4646 12.0283 13.0051C12.0283 13.5456 12.4756 13.983 13.0283 13.983H20.7598C21.3125 13.983 21.7598 13.5456 21.7598 13.0051Z",
    fill: "#007AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0283 18.0443C12.4756 18.0443 12.0283 18.4817 12.0283 19.0222C12.0283 19.5626 12.4756 20 13.0283 20H17.6396C18.1924 20 18.6396 19.5626 18.6396 19.0222C18.6396 18.4817 18.1924 18.0443 17.6396 18.0443H13.0283Z",
    fill: "#007AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0001 0H13.0284C12.4757 0 12.0284 0.437357 12.0284 0.977846C12.0284 1.51833 12.4757 1.95569 13.0284 1.95569H27.0001C27.5529 1.95569 28.0001 1.51833 28.0001 0.977846C28.0001 0.437357 27.5529 0 27.0001 0Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.f41453e967aaaee565803d4cc44f4f90.svg";
export { ForwardRef as ReactComponent };